export default "__VITE_ASSET__8be4f9f5__"